/* eslint-disable @typescript-eslint/no-var-requires */
import { ITopic } from 'config/topics';
import { ApplicationState } from 'redux/reducers';
import { ThunkDispatch } from 'redux-thunk';
import { Action } from 'redux';
import { store } from 'App';
import { sidebarAnimationDuration } from 'components/Sidebar/Sidebar';

export const UPDATE_TOPIC = 'UPDATE_TOPIC';
export const UPDATE_TOPIC_CONTENT_VISIBILITY = 'UPDATE_TOPIC_CONTENT_VISIBILITY';

export const toggleTopicContent = (show: boolean) => {
  return {
    type: UPDATE_TOPIC_CONTENT_VISIBILITY,
    payload: show
  };
};

export const updateTopic = (topic: ITopic) => {
  return async (dispatch: ThunkDispatch<ApplicationState, undefined, Action>) => {
    const sidebarIsOpen = store.getState().topic.contentVisible;

    
    if (sidebarIsOpen) {
      dispatch(toggleTopicContent(false));
    }

    try {
      const { default: markdownFile } = await import(`data/${topic.sidebarContent}`);
      const markdownContent = await (await fetch(markdownFile)).text();
      
      setTimeout(() => {
        dispatch({
          type: UPDATE_TOPIC,
          payload: {
            ...topic,
            sidebarContent: markdownContent
          }
        });
      }, sidebarIsOpen ? sidebarAnimationDuration : 0);
    } catch (err) {
      throw new Error('Fetching markdown went wrong!');
    }
  };
};
